import { getAPIUrl } from '../utils';
import AxiosClient, { getLogOptions } from './axios.service';

export const getActivities = ({ accountId, authToken, filters, page, perPage }) => {
  const baseUrl = getAPIUrl(accountId);

  return AxiosClient.get({
    options: getLogOptions(authToken, getActivities.name),
    params: { page, perPage, ...filters },
    url: `${baseUrl}/activities`,
  });
};

export const getExportActivities = ({ accountId, authToken, filters }) => {
  const baseUrl = getAPIUrl(accountId);

  return AxiosClient.get({
    options: getLogOptions(authToken, getExportActivities.name),
    params: { ...filters },
    url: `${baseUrl}/activities/export`,
  });
};
